<template>
  <v2-modal
    :show="visible"
    size="full"
    title="Product Editing"
    :show-footer="false"
    @close="onModalClose"
  >
    <template #header>
      <div class="v2-product-edit__header">
        <h1 class="v2-product-edit__title">
          Product Editing
        </h1>
      </div>
    </template>

    <v2-product-edit-content
      ref="content"
      presentation="modal"
      :product-id="productId"
      :collection-id="collectionId"
      :wishlist-id="wishlistId"
      @edit-success="onEditSuccess"
      @request-close="emitClose"
    />
  </v2-modal>
</template>

<script>
import V2Modal from '@/components/v2/V2Modal.vue'
import V2ProductEditContent from './V2ProductEditContent.vue'

export default {
  name: 'V2ProductEditModal',
  components: {
    V2Modal,
    V2ProductEditContent,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    productId: {
      type: String,
      default: '',
    },
    collectionId: {
      type: String,
      default: '',
    },
    wishlistId: {
      type: String,
      default: '',
    },
  },
  methods: {
    // Delegate the modal-frame close (X button / backdrop click) to the
    // content child so its unsaved-changes confirmation + analytics tracking
    // run, exactly as they did before the extraction. The content will emit
    // `request-close` back up if the user actually wants to close.
    onModalClose() {
      const content = this.$refs.content
      if (content && typeof content.handleClose === 'function') {
        content.handleClose()
      } else {
        this.emitClose()
      }
    },
    emitClose() {
      this.$emit('close')
    },
    onEditSuccess() {
      this.$emit('edit-success')
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-product-edit {
  &__header {
    display: flex;
    align-items: center;
  }

  &__title {
    font-family: var(--v2-font-display);
    font-size: 1.25rem;
    font-weight: 600;
    color: var(--v2-foreground);
    margin: 0;
  }
}
</style>
